import _ from 'lodash';
class PaymentController {
  constructor(STRIPE_KEY, User, $stateParams, $state,Plans,$scope) {
    "ngInject";
    this.name = 'payment';
    this.STRIPE_KEY = STRIPE_KEY;
    this.User = User;
    this.$state = $state;
    this.$scope = $scope;

    this.plans = Plans.getPlans();
    this.currentPlan = _.find(this.plans, {
      id: $stateParams.planId
    });
  }



  $onInit() {
    let stripe = Stripe(this.STRIPE_KEY);
    this.stripe = stripe;
    let self = this;
    let elements = stripe.elements();
    this.setOutcome = setOutcome;

    let card = elements.create('card', {
      hidePostalCode: true,
      style: {
        base: {
          iconColor: '#F99A52',
          color: '#32315E',
          lineHeight: '25px',
          fontWeight: 400,
          fontFamily: '"Helvetica Neue", "Helvetica", sans-serif',
          fontSize: '15px',
          '::placeholder': {
            color: '#CFD7DF',
          }
        },
      }
    });
    card.mount('#card-element');

    function setOutcome(result) {
      let successElement = document.querySelector('.success');
      let errorElement = document.querySelector('.error');
      successElement.classList.remove('visible');
      errorElement.classList.remove('visible');

      if (result.token) {
        // Use the token to create a charge or a customer
        // https://stripe.com/docs/charges
        self.loading = true;
        self.$scope.$apply();
        self.User.processPayment({
            token: result.token,
            plan: self.currentPlan.id
          }).then(() => {
            console.log('successfully subscribed to users');
            self.loading = false;
            self.User.updateUserOnboarding({
              payment: true
            }).then(() => {
              self.$state.go('onboarding.helpscout');
            });
          })
          .catch(() => {
            self.loading = false;
            console.log('error processing payment');
            errorElement.textContent = 'error processing card details';
            errorElement.classList.add('visible');
          })
      } else if (result.error) {
        errorElement.textContent = result.error.message;
        self.loading = false;
        self.$scope.$apply();
        errorElement.classList.add('visible');
      }
    }

    card.on('change', function(event) {
      setOutcome(event);
    });

    this.card = card;
  }

  submit() {
    this.loading = true;
    let extraDetails = {
      name: this.name,
      email: this.User.getUserEmail()
    };
    this.stripe.createToken(this.card, extraDetails).then(this.setOutcome).catch((err)=>{
      this.loading = false;
    });
  }

}

export default PaymentController;



// WEBPACK FOOTER //
// ./client/app/components/home/onboarding/payment/payment.controller.js